import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../../shared/lib/query-keys.ts";
import {
  getCategories,
  getProjectById,
  getProjects,
  type ProjectsResponse,
} from "../api/leaderboard-api.ts";
import type { LeaderboardFilters } from "../types/filters.ts";
import type { Category, Project } from "../types/index.ts";

const PAGE_SIZE = 50;

export function useCategoriesQuery() {
  return useQuery<Category[]>({
    queryKey: queryKeys.leaderboard.categories(),
    queryFn: () => getCategories(),
  });
}

export function useProjectsQuery(params: {
  page: number;
  sort?: string;
  direction?: "asc" | "desc";
  filters?: LeaderboardFilters;
}) {
  const { page, sort, direction, filters = {} } = params;
  const offset = (page - 1) * PAGE_SIZE;

  return useQuery<ProjectsResponse>({
    queryKey: queryKeys.leaderboard.projects({ page, sort, direction, filters }),
    queryFn: () => getProjects({ limit: PAGE_SIZE, offset, sort, direction, filters }),
  });
}

export function useProjectByIdQuery(projectId: string | null) {
  return useQuery<Project | null>({
    queryKey: queryKeys.leaderboard.project(projectId ?? ""),
    queryFn: () => getProjectById(projectId ?? ""),
    enabled: Boolean(projectId),
  });
}

export { PAGE_SIZE };
